import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { notification, modal } from 'redux/modules/app'
import { configuration as configurationApi } from 'redux/modules/api'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        configuration: api.configuration,
      }),
      { ...configurationApi, notification, modal },
    )
    class Configuration extends Component {
      static propTypes = {
        getConfigurationKeyValue: PropTypes.func.isRequired,
        getConfigurationKeysValues: PropTypes.func.isRequired,
        configuration: PropTypes.object.isRequired,
        notification: PropTypes.func.isRequired,
      }

      componentDidMount() {
        // const { configKey, organizationId } = this.props

        config.getValue && this.handleGetConfigurationValue(config.getValue)
        // configKey && this.handleGetConfigurationValue(configKey, organizationId)
      }

      handleGetConfigurationKeyValue = ({ body = [] }) => {
        body.forEach(configItem =>
          this.props.getConfigurationKeyValue(configItem.name),
        )
      }

      handleGetConfigurationValue = (value, organizationId, removeToken) => {
        return this.props.getConfigurationKeyValue(
          value,
          organizationId,
          removeToken,
        )
      }

      handleGetConfigurationValues = (values, organizationId) => {
        return this.props.getConfigurationKeysValues(values,
          organizationId,
        )
          .catch(this.handleError)
      }

      handleGetRegistrationFieldsCustomization = organizationId => {
        return this.props.getConfigurationKeysValues([
            CONFIGURATION_KEYS.participantRegistrationEmailAddress2.id,
            CONFIGURATION_KEYS.participantRegistrationPhoneType.id,
            CONFIGURATION_KEYS.participantRegistrationSecondaryPhone.id,
            CONFIGURATION_KEYS.participantRegistrationSecPhoneType.id,
            CONFIGURATION_KEYS.participantRegistrationTitle.id,
            CONFIGURATION_KEYS.participantRegistrationMiddleName.id,
            CONFIGURATION_KEYS.participantRegistrationNationality.id,
            CONFIGURATION_KEYS.participantRegistrationEmplStatus.id,
            CONFIGURATION_KEYS.participantRegistrationAddressLine2.id,
            CONFIGURATION_KEYS.participantRegistrationAddressLine1.id,
            CONFIGURATION_KEYS.participantRegistrationPhoneNumber.id,
            CONFIGURATION_KEYS.participantRegistrationAddressCity.id,
            CONFIGURATION_KEYS.participantRegistrationAddressZipCode.id,
            CONFIGURATION_KEYS.participantRegistrationAddressRegion.id,
            CONFIGURATION_KEYS.participantRegistrationAddressCountry.id,

            CONFIGURATION_KEYS.participantAge.id,
            CONFIGURATION_KEYS.postalAddress.id,
            CONFIGURATION_KEYS.participantRegistrationTitle.id,
            CONFIGURATION_KEYS.participantRegistrationMiddleName.id,
            CONFIGURATION_KEYS.participantRegistrationNationality.id,
            CONFIGURATION_KEYS.participantRegistrationEmplStatus.id,
            CONFIGURATION_KEYS.participantRegistrationAddressLine2.id,
          ],
          organizationId,
        )
          .catch(this.handleError)
      }

      handleGetLeaderRegistrationFieldsCustomization = organizationId => {
        return this.props.getConfigurationKeysValues([
            CONFIGURATION_KEYS.organizationContactEmailAddress2.id,
            CONFIGURATION_KEYS.organizationContactPhoneNumber.id,
            CONFIGURATION_KEYS.participantRegistrationSecondaryPhone.id,
            CONFIGURATION_KEYS.organizationContactMiddleName.id,
            CONFIGURATION_KEYS.organizationContactGender.id,
            CONFIGURATION_KEYS.organizationContactDateOfBirth.id,
            CONFIGURATION_KEYS.organizationContactAddressLine1.id,
            CONFIGURATION_KEYS.organizationContactAddressLine2.id,
            CONFIGURATION_KEYS.organizationContactAddressCity.id,
            CONFIGURATION_KEYS.organizationContactAddressZipCode.id,
            CONFIGURATION_KEYS.organizationContactAddressRegion.id,
            CONFIGURATION_KEYS.organizationContactAddressCountry.id,
            CONFIGURATION_KEYS.organizationContactRole.id,
            CONFIGURATION_KEYS.organizationContactTitle.id
          ],
          organizationId,
        )
          .catch(this.handleError)
      }

      handleGetOrgContactRegistrationFieldsCustomization = organizationId => {
        return this.props.getConfigurationKeysValues([
            CONFIGURATION_KEYS.organizationContactEmailAddress2.id,
            CONFIGURATION_KEYS.organizationContactPhoneNumber.id,
            CONFIGURATION_KEYS.organizationContactMiddleName.id,
            CONFIGURATION_KEYS.organizationContactGender.id,
            CONFIGURATION_KEYS.organizationContactDateOfBirth.id,
            CONFIGURATION_KEYS.organizationContactAddressLine1.id,
            CONFIGURATION_KEYS.organizationContactAddressLine2.id,
            CONFIGURATION_KEYS.organizationContactAddressCity.id,
            CONFIGURATION_KEYS.organizationContactAddressZipCode.id,
            CONFIGURATION_KEYS.organizationContactAddressRegion.id,
            CONFIGURATION_KEYS.organizationContactAddressCountry.id,
          ],
          organizationId,
        )
          .catch(this.handleError)
      }

      handleGetAwardUnitRegistrationFieldsCustomization = organizationId => {
        return this.props.getConfigurationKeysValues([
            CONFIGURATION_KEYS.organizationContactPhoneNumber.id,
            CONFIGURATION_KEYS.organizationContactMiddleName.id,
            CONFIGURATION_KEYS.organizationContactGender.id,
            CONFIGURATION_KEYS.organizationContactAddressLine1.id,
            CONFIGURATION_KEYS.organizationContactAddressLine2.id,
            CONFIGURATION_KEYS.organizationContactAddressCity.id,
            CONFIGURATION_KEYS.organizationContactAddressZipCode.id,
            CONFIGURATION_KEYS.organizationContactAddressRegion.id,
            CONFIGURATION_KEYS.organizationContactAddressCountry.id,
          ],
          organizationId,
        )
          .catch(this.handleError)
      }

      isConfigurationTrue = configKey => {
        const values = this.props.configuration && this.props.configuration.values

        const value = values && values[configKey]

        return value ? Boolean(value.booleanValue) : false
      }

      handleError = ({ body }) => {
        console.debug('error', body.userMessage)
        this.props.notification(body.userMessage, 'error')
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onGetConfigurationValue={this.handleGetConfigurationValue}
            onGetConfigurationValues={this.handleGetConfigurationValues}
            handleGetRegistrationFieldsCustomization={this.handleGetRegistrationFieldsCustomization}
            handleGetLeaderRegistrationFieldsCustomization={this.handleGetLeaderRegistrationFieldsCustomization}
            handleGetOrgContactRegistrationFieldsCustomization={this.handleGetOrgContactRegistrationFieldsCustomization}
            handleGetAwardUnitRegistrationFieldsCustomization={this.handleGetAwardUnitRegistrationFieldsCustomization}
            isConfigurationTrue={this.isConfigurationTrue}
          />
        )
      }
    }

    return Configuration
  }
}

export default decorator
